import React from "react";
import Navbar from "./components/navbar";
import CreateOfertacelComponent from "./create/create.component";
import CreateOfertacelProvider from "./create/provider/createOfertacel.provider";
import CreateUsedOfertacelProvider from "./create/used/provider/createUsedOfertacel.provider";
import CreateNewsOfertacelProvider from "./create/news/provider/createNewsOfertacel.provider";

const OfertacelPage = () => {
  return (
    <CreateOfertacelProvider>
      <CreateNewsOfertacelProvider>
        <CreateUsedOfertacelProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#000]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateOfertacelComponent />
              </div>
            </section>
          </div>
        </CreateUsedOfertacelProvider>
      </CreateNewsOfertacelProvider>
    </CreateOfertacelProvider>
  );
};

export default OfertacelPage;
